import PropTypes from 'prop-types';

// TODO: to revist the structure after the service
export const TOPIC_FAQ_ITEM = {
  id: PropTypes.string,
  title: PropTypes.string,
  solutionId: PropTypes.string,
  solutionClass: PropTypes.string,
  topicId: PropTypes.string,
};

export const TOPIC = {
  id: PropTypes.string,
  name: PropTypes.string,
  faqList: PropTypes.arrayOf(PropTypes.shape(TOPIC_FAQ_ITEM)),
};

export const ARTICLE_LIST = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  articleList: PropTypes.arrayOf(PropTypes.shape(TOPIC)),
};

export const COMMUNITY = {
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
  results: PropTypes.arrayOf(PropTypes.shape({
    articleTitle: PropTypes.string,
    articleId: PropTypes.number,
    views: PropTypes.number,
    link: PropTypes.string,
  })),
};

export const BREADCRUMB_ITEM = {
  id: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.string,
};

export const CHANNEL_DETAIL_BNA = {
  bnaId: PropTypes.string,
  bnaListId: PropTypes.string,
  intentId: PropTypes.string,
  intentPromptedTime: PropTypes.string,
};

export const POPULAR_ARTICLE = {
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  channel: PropTypes.string,
  channelDetails: PropTypes.shape(CHANNEL_DETAIL_BNA),
  rank: PropTypes.number,
  usage: PropTypes.number,
};

export const CASE_PARTIES = {
  association: PropTypes.string,
  user_id: PropTypes.string,
  user_type: PropTypes.string,
};

export const OPEN_CASE = {
  amount: PropTypes.shape({
    currency_code: PropTypes.string,
    value: PropTypes.string,
  }),
  case_lifecycle_stage: PropTypes.string,
  case_parties: PropTypes.arrayOf(PropTypes.shape(CASE_PARTIES)),
  case_type: PropTypes.arrayOf(PropTypes.string),
  claim_type: PropTypes.string,
  creation_timestamp: PropTypes.string,
  detailed_case_status: PropTypes.string,
  facilitator_id: PropTypes.string,
  id: PropTypes.string,
  origin: PropTypes.string,
  policy_name: PropTypes.string,
  reason_code: PropTypes.string,
  status: PropTypes.string,
};

export const ARTICLE_CONTENT = {
  articleContent: PropTypes.string,
  articleId: PropTypes.string,
  articleTitle: PropTypes.string,
  breadCrumbPath: PropTypes.string,
  breadCrumbTitle: PropTypes.string,
  consumerContent: PropTypes.string,
  rank: PropTypes.number,
  topicId: PropTypes.string,
  topicName: PropTypes.string,
  usage: PropTypes.number,
};

export const MACHINE_ARTICLE = {
  article: PropTypes.shape(ARTICLE_CONTENT),
  error: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export const ELMO_TREATMENT = {
  elmoTreatments: PropTypes.string,
};

export const ICF_ARTICLE = {
  article_id: PropTypes.string,
  title: PropTypes.string,
  rank: PropTypes.number,
  article_content: PropTypes.string,
  status: PropTypes.string,
};

export const ICF_CONTENT = {
  customer_experience: PropTypes.string,
  icf_id: PropTypes.number,
  icf_summary: PropTypes.string,
  icf_title: PropTypes.string,
  locale: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.shape(ICF_ARTICLE)),
};

export const ICF_GUIDE = {
  description: PropTypes.string,
  icf_id: PropTypes.string,
  icf_title: PropTypes.string,
  internal_lable: PropTypes.string,
  user_experience: PropTypes.string,
};

export const DISPUTE_CASE = {
  create_time: PropTypes.string,
  dispute_amount: PropTypes.shape({
    currency_code: PropTypes.string,
    value: PropTypes.string,
  }),
  dispute_channel: PropTypes.string,
  dispute_flow: PropTypes.string,
  dispute_id: PropTypes.string,
  dispute_life_cycle_stage: PropTypes.string,
  dispute_state: PropTypes.string,
};

export const OMNI_CHANNEL_ARTICLE = {
  intentCode: PropTypes.string,
  intentArticle: PropTypes.string,
};
